import { Directive, HostBinding } from '@angular/core';

/**
 * This attaches the ngSkipHydration attribute to any components with attributes
 * that don't work with hydration:
 * - `maxLines` - as we manipulate the DOM to truncate the text
 * - `innerHTML` - which just plain doesn't work
 *
 * This needs to be a directive as it needs to be applied where the content is,
 * which is usually in the highest-level component that has a `maxLines` input.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[maxLines], [flMaxLines], [innerHTML]',
})
export class TextInvalidAttributeSkipHydrationDirective {
  @HostBinding('attr.ngSkipHydration') ngSkipHydration = 'true';
}
